module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-Hant":{"aboutN":"大約 {0}"},"en":{"aboutN":"{0}"}}')
  delete Component.options._Ctor
}
